export const locale = {
  sub_header: 'Required field',
};
